'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.disableActivity = disableActivity;
exports.activity = activity;
exports.isActive = isActive;
var APP_ACTIVITY = +new Date();
var DISABLE_ACTIVITY = false;

function disableActivity() {
  DISABLE_ACTIVITY = true;
}

window.disableActivity = disableActivity;

function activity() {
  APP_ACTIVITY = +new Date();

  if (window.parent && window.parent.postMessage) {
    window.parent.postMessage({
      type: 'ACTIVITY'
    }, '*');
  }
}

function isActive(miliseconds) {
  if (DISABLE_ACTIVITY) return true;
  var lastActivity = APP_ACTIVITY;
  return +new Date() - lastActivity < miliseconds;
}